<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header = "Información del Banco">
          <b-form>
            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim= "$v.nombre.$model"
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-pais
              label="Pais"
              :nombre="paisNombre"
              :lista="paisesList"
              :valido="paisValido"
              :msjInvalido="paisInvalidoMsj"
              :labelCols="labelCols"
              @validate="validate"
              @updated="paisActualizado">
            </app-pais>  

            <b-form-group
              label-for="inactivo"
              :label-cols="labelCols">
              <b-form-checkbox 
                  id="inactivo"
                  v-model="inactivo"
                  value= true
                  unchecked-value= false>
                  Inactivo
              </b-form-checkbox>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>  

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Pais from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, maxLength, numeric, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'banco/getField',
  mutationType: 'banco/updateField',
});

export default {
  name: 'BancosABM',
  components: {
    appPais: Pais,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      nombreValido: null,
      nombreInvalidoMsj: '',
      paisValido: null,
      paisInvalidoMsj: '',

      labelCols: 1,

      paises: [],
      paisesList: [],
      loadingPaises: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'nombre',
      'pais',
      'paisNombre',
      'inactivo',
    ])
  },
  created() {
    let bancoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        bancoId = this.$route.params.id;
      }
    }

    this.loadingPaises = true;

    this.showSpinner();
    this.$store.dispatch('banco/inicializar', bancoId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner())
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this;
      
      this.$store.dispatch('paises/getPaisesSelect')
        .then(() => {
          vm.paises = this.$store.getters['paises/paisesSelect'];
          vm.paisesList = this.$store.getters['paises/listSelect'];
          this.loadingPaises = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de paises.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == "nombre" || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (this.$v.nombre.$error && !this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres';
          }      
          if (this.$v.nombre.$error && !this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre del banco';
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true; 

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let pais = null;
      if (this.paisNombre) {
        pais = this.getSelected(this.paises, this.paisNombre);
      }
      this.$store.dispatch('banco/setPais', pais);

      let paisError = Boolean(true);
      if (this.pais) {
        if (this.pais.id) {
          if (this.pais.id != 0) {
            paisError = Boolean(false);
          }
        }
      }
      if (paisError) {
        save = Boolean(false);
        this.paisValido = false;
        this.paisInvalidoMsj = 'Debe seleccionar el país correspondiente';
      }

      this.$v.$touch()

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('banco/save', this.id)
            .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      }
    },
    goList() {
      this.$router.push({ name: "Bancos" });
    },
    paisActualizado(paisNombre) {
      if (!this.loadingPaises) {
        this.paisNombre = paisNombre;
        
        this.paisValido = null;
        this.paisInvalidoMsj = '';
      }
    },
  },
  validations: {
    nombre: {
      required,
      maxLength: maxLength(50)
    },
  },  
}
</script>

<style>
</style>
